module.exports = __webpack_public_path__ + "img/reginato_p.c6d847f5.jpg";